const ROLES = {
  ADMIN: 1,
  //COORD: = 2; // NOT USE,
  INSPECTOR_SIC: 3,
  ADMIN_COOP: 4,
  COMITE_APROBACION: 5,
  ACOPIADOR: 6,
  //ADMIN_NUUP: = 7;  // NOT USE,
  ACOPIADOR_GENERAL: 8,
};

export default ROLES;
